import { useLanguage } from '../../context/LanguageContext';
import { PHONE } from '../../utils/schema';
import { trackPhoneClick } from '../../utils/tracking';
import PhoneIcon from './PhoneIcon';

// Mobile-only bottom bar (most ad traffic is on phones): call + callback request.
// Pages using it need ~80px bottom padding so the bar never covers content.
export default function StickyCtaBar({ onCallback, placement = 'sticky_bar' }) {
  const { t } = useLanguage();

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 xl:hidden bg-white/95 backdrop-blur border-t border-gray-200 px-3 pt-2 flex gap-2"
      style={{ paddingBottom: 'calc(0.5rem + env(safe-area-inset-bottom))' }}
    >
      <a
        href={`tel:${PHONE}`}
        onClick={() => trackPhoneClick(placement)}
        className="flex-1 flex items-center justify-center gap-2 rounded-xl py-3 bg-black text-dewalt font-extrabold text-[15px] no-underline active:scale-[0.97] transition-transform"
      >
        <PhoneIcon size={18} />
        {t('rentPage.callNow')}
      </a>
      <button
        type="button"
        onClick={onCallback}
        className="flex-1 rounded-xl py-3 bg-dewalt text-black font-extrabold text-[15px] border-none cursor-pointer active:scale-[0.97] transition-transform"
      >
        {t('rentPage.callbackBtn')}
      </button>
    </div>
  );
}
